import React from "react";
import ResultContainer from "../containers/ResultContainer";

const ResultPage = ({ match }) => {
  window.history.pushState(null, null, window.location.href);
  let token = "";
  if (match) {
    token = match.params.token;
  }
  return (
    <>
      <ResultContainer token={token}></ResultContainer>
    </>
  );
};

export default ResultPage;
